import { Box } from "@zenchef/styled-system/jsx";
import Button from "../Button/Button";
import { Action } from "../../utils/types";

export interface FooterExposedProps {
  /**
   * Label to show and action to perform on click on primary button in the footer
   */
  primaryAction: Action;
  /**
   * Label to show and action to perform on click on secondary button in the footer, if undefined, button wont be shown
   */
  secondaryAction?: Action;
  /**
   * Primary button color
   */
  primaryHierarchy?: "primary-bold" | "destructive-bold";
  /**
   * Secondary button color
   */
  secondaryHierarchy?: "secondary-subtle" | "secondary-subtler";
}
export interface FooterInternalProps extends FooterExposedProps {
  className?: string;
}

export default function ContainerFooter({
  primaryAction,
  secondaryAction,
  primaryHierarchy = "primary-bold",
  secondaryHierarchy = "secondary-subtle",
  className,
}: FooterInternalProps) {
  return (
    <Box className={className}>
      {secondaryAction ? (
        <Button
          {...secondaryAction}
          hierarchy={secondaryHierarchy}
          onClick={secondaryAction.onClick}
        >
          {secondaryAction.label}
        </Button>
      ) : null}
      {primaryAction ? (
        <Button
          {...primaryAction}
          hierarchy={primaryHierarchy}
          onClick={primaryAction.onClick}
        >
          {primaryAction.label}
        </Button>
      ) : null}
    </Box>
  );
}
